class SessionStorageService {
  setBasketData = (basketData) => {
    sessionStorage.setItem('basketData', JSON.stringify(basketData));
  };
  setSubscriptionData = (basketData) => {
    sessionStorage.setItem(
      'subscriptionBasketData',
      JSON.stringify(basketData)
    );
  };
  getBasketData = () => {
    const data = sessionStorage.getItem('basketData') ?? null;
    return JSON.parse(data);
  };
  getSubscriptionBasketData = () => {
    const data = sessionStorage.getItem('subscriptionBasketData') ?? null;
    return JSON.parse(data);
  };
}

export default new SessionStorageService();
